<template>
    <div id="notifications">
        <div v-if="moreErrors" v-for="message in messages" class="alert alert-danger" role="alert">
            <button class="close" data-dismiss="alert"></button>
            <strong v-for="e in message" v-text="e"></strong>
        </div>

        <div v-if="!moreErrors && error.message" class="alert alert-danger" role="alert">
            <button class="close" data-dismiss="alert"></button>
            <strong v-for="e in error.message" v-text="e"></strong>
        </div>
    </div>
</template>

<script>
    export default {
      props: [ 'error' ],

      created () {
       console.error(this.error)
      },

      computed: {
        moreErrors () {
          return this.error.hasOwnProperty("errors")
        },

        messages () {
          return this.moreErrors && _.values(this.error.errors)
        }
      }
    }
</script>



// WEBPACK FOOTER //
// client/components/ConsumptionProducts/ErrorNotification.vue